
import { Input } from "@/components/ui/input";
import { Badge } from "@/components/ui/badge";
import { X } from "lucide-react";
import { useState } from "react";

interface IngredientInputProps {
  ingredients: string[];
  onAddIngredient: (ingredient: string) => void;
  onRemoveIngredient: (ingredient: string) => void;
}

export const IngredientInput = ({
  ingredients,
  onAddIngredient,
  onRemoveIngredient,
}: IngredientInputProps) => {
  const [newIngredient, setNewIngredient] = useState("");

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" && newIngredient.trim()) {
      e.preventDefault();
      onAddIngredient(newIngredient.trim());
      setNewIngredient("");
    }
  };

  return (
    <div className="space-y-2">
      <Input
        value={newIngredient}
        onChange={(e) => setNewIngredient(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder="Press Enter to add"
        className="text-black bg-[#EDEDED] border-gray-200 placeholder:text-[#6B6B6B]"
      />
      <div className="flex flex-wrap gap-2">
        {ingredients.map((item, index) => (
          <Badge key={index} variant="outline" className="flex items-center gap-1">
            {item}
            <X
              className="h-3 w-3 cursor-pointer"
              onClick={() => onRemoveIngredient(item)}
            />
          </Badge>
        ))}
      </div>
    </div>
  );
};
